/**
 * Payment cancel landing page.
 *
 * Reached when a user closes / cancels the Stripe hosted-checkout tab.
 * No side effects — no session id is needed to render honest copy.
 */
import { Link } from "react-router-dom";
import { AppShell } from "@/components/AppShell";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";


export default function PaymentCancel() {
  return (
    <AppShell>
      <div
        data-testid="payment-cancel-page"
        className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8 py-12 sm:py-20 text-center"
      >
        <XCircle className="h-10 w-10 text-fg-muted mx-auto" aria-hidden="true" />
        <h1
          data-testid="payment-cancel-title"
          className="mt-4 text-3xl font-heading text-fg-primary"
        >
          Checkout cancelled
        </h1>
        <p className="mt-2 text-sm text-fg-secondary">
          Nothing was charged. You can return to the plans page and pick
          again whenever you're ready.
        </p>
        <div className="mt-6 flex justify-center gap-3">
          <Link to="/plans">
            <Button data-testid="payment-cancel-back-to-plans-btn">
              Back to plans
            </Button>
          </Link>
          <Link to="/dashboard">
            <Button
              variant="outline"
              data-testid="payment-cancel-go-dashboard-btn"
            >
              Go to dashboard
            </Button>
          </Link>
        </div>
      </div>
    </AppShell>
  );
}
